export default __webpack_public_path__ + "static/indoor11-5e1636421491b436fd9c018c0742c600.webp";